import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import ParkRoundedIcon from '@mui/icons-material/ParkRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';

const iconMap = {
  library: { icon: <AutoStoriesRoundedIcon />, bg: '#f472b6' },
  mini_task: { icon: <EmojiEventsRoundedIcon />, bg: '#4ade80' },
  stars: { icon: <StarRoundedIcon />, bg: '#facc15' },
  forest: { icon: <ParkRoundedIcon />, bg: '#38bdf8' },
};

const fallbackNotes = [
  { type: 'library', text: 'Kitap yolculuğumuz devam ediyor' },
  { type: 'mini_task', text: 'Mini görevler için kartına dokun' },
  { type: 'stars', text: 'Yeni yıldızlar için hazırız' },
  { type: 'forest', text: 'Ormanımız bu hafta büyümeyi bekliyor' },
];

export default function WeeklyNotesTicker({ notes = [] }) {
  const visible = (notes.length ? notes : fallbackNotes).slice(0, 4);

  return (
    <Box
      sx={{
        borderRadius: 2,
        border: '3px solid #c084fc',
        bgcolor: '#faf5ff',
        p: { xs: 1.2, md: 1.35 },
        minHeight: { xs: 210, md: 244 },
        boxShadow: '0 6px 0 rgba(15,23,42,0.06), inset 0 0 0 2px rgba(255,255,255,0.72)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.8, mb: 1.1 }}>
        <AssignmentRoundedIcon sx={{ color: '#5b21b6', fontSize: 27 }} />
        <Typography sx={{ fontWeight: 1000, color: '#5b21b6', fontSize: { xs: 20, md: 24 }, lineHeight: 1.05, textAlign: 'center' }}>
          Bu Haftadan Kısa Notlar
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1, justifyContent: 'center' }}>
        {visible.map((note, idx) => {
          const item = iconMap[note.type] || { icon: <StarRoundedIcon />, bg: '#a78bfa' };
          return (
            <Box
              key={`${note.type || 'note'}-${idx}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.1,
                bgcolor: 'rgba(255,255,255,0.9)',
                borderRadius: 2,
                px: 1,
                py: 0.75,
                minHeight: 42,
                boxShadow: '0 2px 7px rgba(88,28,135,0.08)',
              }}
            >
              <Box
                sx={{
                  width: 34,
                  height: 34,
                  flex: '0 0 34px',
                  borderRadius: '50%',
                  bgcolor: item.bg,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: 'inset 0 -3px 0 rgba(15,23,42,0.12)',
                  '& svg': { fontSize: 21 },
                }}
              >
                {item.icon}
              </Box>
              <Typography sx={{ color: '#242061', fontWeight: 900, fontSize: { xs: 14, md: 16 }, lineHeight: 1.16 }}>
                {note.text}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
